import {
  BeginSealDeviceMethodInterceptor,
  OperationDeviceMethodInterceptor
} from "@hybird/device/interceptor/beginSeal/core";
import {DeviceEvent} from "@hybird/core/device/protocol";
import NoSleep from "nosleep.js"

const noSleep = window.navigator != null ? new NoSleep() : undefined;

const start = async (self) => {
  let _connectId = (connectId += 1);
  await noSleep?.enable();

  self.once(DeviceEvent.END_SEAL, () => {
    if (_connectId === connectId) {
      noSleep?.disable();
    }
  });
}
let connectId = 0;

export class NoSleepBeginSealInterceptor extends BeginSealDeviceMethodInterceptor {

  async beginSeal(proceed, self, params = {}) {
    await start(self);

    return proceed(params);
  }

  isSupport(self) {
    return true;
  }
}

export class NoSleepOperationDeviceMethodInterceptor extends OperationDeviceMethodInterceptor {

  async beginSeal(proceed, self, params = {}) {
    await start(self);

    return proceed(params);
  }

  isSupport(self) {
    return true;
  }
}
